<template>
  <div style="display: flex; flex-direction: column">
    <v-text-field
      v-model="customState.name"
      label="Name"
      outlined
      dense></v-text-field>
    <v-text-field
      v-model="customState.email"
      label="Email"
      outlined
      dense></v-text-field>
    <v-textarea
      v-model="customState.message"
      label="Message"
      outlined
      dense></v-textarea>
  </div>
</template>
<script setup>
const props = defineProps(['customState', 'masterObj']);
</script>
<style scoped></style>
